import { cn } from '@/lib/utils'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs'

interface ITab {
    value: string
    label: React.ReactNode
    content: React.ReactNode
    disabled?: boolean
}

interface IProps {
    tabs: ITab[]
    className?: string
    defaultValue?: string
}

export function SimpleTabs(props: IProps) {
    const isSingleTab = props.tabs.length === 1

    return (
        <div className={cn('flex flex-col gap-6 max-w-full', props.className)}>
            <Tabs defaultValue={props.defaultValue || props.tabs.at(0)?.value}>
                <TabsList>
                    {isSingleTab ? (
                        <TabsTrigger
                            key={props.tabs[0].value}
                            value={props.tabs[0].value}
                            disabled
                        >
                            {props.tabs[0].label}
                        </TabsTrigger>
                    ) : (
                        props.tabs.map(tab => (
                            <TabsTrigger
                                key={tab.value}
                                value={tab.value}
                                disabled={tab.disabled}
                            >
                                {tab.label}
                            </TabsTrigger>
                        ))
                    )}
                </TabsList>
                {props.tabs.map(tab => (
                    <TabsContent key={tab.value} value={tab.value}>
                        {tab.content}
                    </TabsContent>
                ))}
            </Tabs>
        </div>
    )
}
